import Vue from 'vue'
import VueResource from 'vue-resource'
import md5 from 'blueimp-md5'

Vue.use(VueResource)

function getBrowser() {
    let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name: 'IE', version: (tem[1] || '')};
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
            return {name: 'Opera', version: tem[1]};
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0],
        version: M[1]
    };
}

export default {
    getAppList(success_callback, fail_callback) {
        Vue.http.get('store/get_app').then(
            (response) => {
                let apiResult = response.data;
                let apiCode = parseInt(apiResult.code);
                if (apiCode === 0) {
                    success_callback(apiResult.result.appList);
                } else {
                    fail_callback(apiCode);
                }
            },
            () => {
                fail_callback(-1);
            }
        );
    },
    getGoodsList(appId, success_callback, fail_callback) {
        Vue.http.get('store/get_app_goods?app_id=' + appId).then(
            (response) => {
                let apiResult = response.data;
                let apiCode = apiResult.code;
                if (apiCode == 0) {
                    let goods = {
                        appId: appId,
                        goodsList: apiResult.result.goodsList
                    };
                    success_callback(goods);
                } else {
                    fail_callback(apiCode);
                }
            },
            () => {
                fail_callback(-1);
            }
        );
    },
    getPlayedGames(params, success_callback, fail_callback) {
        Vue.http.get('store/get_played_app?uid=' + params.uid + '&token=' + params.accessToken).then(
            (response) => {
                let apiResult = response.data;
                let apiCode = apiResult.code;
                if (apiCode == 0) {
                    success_callback(apiResult.result.appList);
                } else {
                    fail_callback(apiCode);
                }
            },
            () => {
                fail_callback(-1);
            }
        );
    },
    getServerList(params, success_callback, fail_callback) {
        Vue.http.get('store/get_server?uid=' + params.uid + '&app_id=' + params.appId + '&area_id=' + params.areaId).then(
            (response) => {
                let apiResult = response.data;
                let apiCode = apiResult.code;
                if (apiCode == 0) {
                    success_callback(apiResult.result.server_list);
                } else {
                    fail_callback(apiCode);
                }
            },
            () => {
                fail_callback(-1);
            }
        );
    },
    getRoleInfo(params, success_callback, fail_callback) {
        Vue.http.get('store/get_role?uid=' + params.uid + '&app_id=' + params.appId + '&area_id=' + params.areaId + '&server_id=' + params.serverId + '&cp_uid=' + params.cpUid + '&token=' + params.token ).then(
            (response) => {
                let apiResult = response.data;
                let apiCode = apiResult.code;
                if (apiCode == 0) {
                    success_callback(apiResult.result.role_infos);
                } else {
                    fail_callback(apiCode);
                }
            },
            () => {
                fail_callback(-1);
            }
        );
    },
    egBuyGoods(params, success_callback, fail_callback) {
        params.browserName = getBrowser().name;
        params.browserVersion = getBrowser().version;
        params.password = md5(params.password);

        Vue.http.post('store/pay', params).then(
            (response) => {
                success_callback(response.data);
            },
            () => {
                fail_callback(-1);
            }
        );
    },
}



// WEBPACK FOOTER //
// ./src/api/consume.js